module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ClanInfoPanel/images/shadow.6273dfb0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ClanInfoPanel/images/shadow.png
// module id = 3269
// module chunks = 11